// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { post, put } from '../../../../common/api'
import { ADD_MODULES, EDIT_MODULES, GET_MODULES, MODULES } from '../../../../common/constant'

export const actionModules = createAsyncThunk('appModules/actionModules', async (params, thunkAPI) => {
    return await post(MODULES, params, thunkAPI)
})

export const actionAddModules = createAsyncThunk('appModules/actionAddModules', async (params, thunkAPI) => {
    return await put(ADD_MODULES, params, thunkAPI)
})

export const actionGetModules = createAsyncThunk('appModules/actionGetModules', async (params, thunkAPI) => {
    return await post(GET_MODULES, params, thunkAPI)
})

export const actionEditModules = createAsyncThunk('appModules/actionEditModules', async (params, thunkAPI) => {
    return await post(EDIT_MODULES, params, thunkAPI)
})

export const appModulesSlice = createSlice({
    name: 'appModules',
    initialState: {
        //list
        loading: false,
        modules: null,

        //add
        loadingAdd: false,
        addModules: null,

        //get
        loadingGet: false,
        getModules: null,

        //edit
        loadingEdit: false,
        editModules: null

    },
    reducers: {
        //reset or delete Add Insurance Company store data
        resetModulesResponse: (state) => {
            state.modules = null
        },
        resetAddModulesResponse: (state) => {
            state.addModules = null
        },
        resetGetModulesResponse: (state) => {
            state.getModules = null
        },
        resetEditModulesResponse: (state) => {
            state.editModules = null
        }
    },
    extraReducers: builder => {
        builder
            //list
            .addCase(actionModules.pending, (state) => {
                state.loading = true
            })
            .addCase(actionModules.fulfilled, (state, action) => {
                state.loading = false
                state.modules = action.payload
            })
            .addCase(actionModules.rejected, (state) => {
                state.loading = false
            })

            //add
            .addCase(actionAddModules.pending, (state) => {
                state.loadingAdd = true
            })
            .addCase(actionAddModules.fulfilled, (state, action) => {
                state.loadingAdd = false
                state.addModules = action.payload
            })
            .addCase(actionAddModules.rejected, (state) => {
                state.loadingAdd = false
            })

            //get
            .addCase(actionGetModules.pending, (state) => {
                state.loadingGet = true
            })
            .addCase(actionGetModules.fulfilled, (state, action) => {
                state.loadingGet = false
                state.getModules = action.payload
            })
            .addCase(actionGetModules.rejected, (state) => {
                state.loadingGet = false
            })

            //edit
            .addCase(actionEditModules.pending, (state) => {
                state.loadingEdit = true
            })
            .addCase(actionEditModules.fulfilled, (state, action) => {
                state.loadingEdit = false
                state.editModules = action.payload
            })
            .addCase(actionEditModules.rejected, (state) => {
                state.loadingEdit = false
            })
    }
})
export const { resetModulesResponse, resetAddModulesResponse, resetGetModulesResponse, resetEditModulesResponse } = appModulesSlice.actions

export default appModulesSlice.reducer